<template>
  <div
    @mousemove="mousemoveHandler"
    v-touch:swipe.top="swipeHandler" v-touch:swipe.bottom="swipeHandler"
    class="home-hero-slider">
    <girl-wave
      :mouseX="mouseX"
      :initWave="needWave"
      :clickSwitch="clickSwitch"
      @toggle-content-hide="toggleHideOnAnim"
      @toggle-play-title="togglePlayTitle">
    </girl-wave>

    <img @click="clickSwitch = 1" class="content-switch content-switch__psoriasis content-switch--left" src="../../assets/switch-psoriasis.png" width="24" height="81">
    <img @click="clickSwitch = 2" class="content-switch content-switch__tremfya content-switch--right" src="../../assets/switch-tremfya.png"  width="24" height="81">

    <div v-show="firstScreen === false">
      <div class="hero-content hero-content--left contentLeft">
        <router-link :to="{ name: 'Psoriasis' }" class="link-box"></router-link>
        <div class="box">
          <div class="bg-letter">P</div>
          <div class="sign">
            <anim-text color="#00B2AA" :play="playPsoriasisTitle">Moderate to Severe</anim-text>
          </div>
          <h2>
            <anim-text color="#00B2AA" bgHeight="82" delay=".5" :play="playPsoriasisTitle" >PLAQUE PSORIASIS</anim-text>
          </h2>
          <div class="learn-more headTitleLMoreLink">Learn More</div>
        </div>
      </div>
      <h3 v-show="!hideOnAnim">
        <div>
          <span class="sign">Moderate to Severe</span>
          <span class="title">PLAQUE PSORIASIS</span>
        </div>
      </h3>
      <div class="hero-content hero-content--right contentRight" v-show="!hideOnAnim">
        <router-link :to="{ name: 'Tremfya' }" class="link-box"></router-link>
        <div class="box">
          <div class="bg-letter">T</div>
          <h2>
            <anim-text color="#FFCC49" :play="playTremfyaTitle">TREMFYA<sup v-if="userAgent.device.isMobile">®</sup></anim-text>
            <sup v-if="!userAgent.device.isMobile">®</sup>
          </h2>
          <div class="sign">
            <anim-text color="#FFCC49" delay=".5" bgHeight="105" :play="playTremfyaTitle" >(guselkumab)</anim-text>
          </div>
          <div class="learn-more headTitleLMoreLink">Learn More</div>
        </div>
      </div>
      <h3>
        <div>
          <span class="title">TREMFYA<sup>®</sup></span>
          <span class="sign">(guselkumab)</span>
        </div>
      </h3>
    </div>

    <intro
      v-if="!$store.state.homeIntroInited"
      @hide-first-screen="initSecondScreen"
      :swipe="swipeCounter"></intro>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import Intro from './Intro';
import GirlWave from './GirlWave';

export default {
  components: {
    Intro,
    GirlWave
  },
  data() {
    return {
      mouseX: 0,
      clickSwitch: 0,
      firstScreen: true,
      needWave: false,
      hideOnAnim: false,
      swipeCounter: 0,
      playPsoriasisTitle: false,
      playTremfyaTitle: false
    };
  },
  computed: {
    ...mapState(['userAgent'])
  },
  methods: {
    swipeHandler() {
      if (this.swipeCounter < 2) {
        this.swipeCounter++;
      }
    },
    togglePlayTitle(togglePsoriasis = true) {
      if (togglePsoriasis) {
        this.playPsoriasisTitle = !this.playPsoriasisTitle;
      } else {
        this.playTremfyaTitle = !this.playTremfyaTitle;
      }
    },
    toggleHideOnAnim() {
      this.hideOnAnim = !this.hideOnAnim;
    },
    initSecondScreen() {
      this.firstScreen = false;
      this.needWave = true;
    },
    mousemoveHandler(e) {
      this.mouseX = e.clientX;
    }
  },
  mounted() {
    if (this.$store.state.homeIntroInited) {
      this.initSecondScreen();
    }
  }
};
</script>

<style lang="scss" src="./HomeHero.scss">
</style>
